/**
 * UserInfo Component
 * Displays user name from decoded JWT token
 * Only shown when user is authenticated
 */

import { useAuthContext } from '../../contexts/AuthContext';

/**
 * UserInfo component
 * Displays a welcome message with the user's name
 * Only visible when user is authenticated
 * 
 * @returns User info component or null if not authenticated
 */
export function UserInfo() {
  const { isAuthenticated, user, isLoading } = useAuthContext();

  // Only show when authenticated and not loading
  if (!isAuthenticated || isLoading || !user) {
    return null;
  }

  // Extract display name (prefer given_name, fallback to name, then email)
  const displayName = user.given_name || user.name || user.email;

  return (
    <div style={{
      color: 'var(--color-accent)',
      fontSize: 'var(--font-size-xs)'
    }}>
      🎵 Welcome, {displayName}
    </div>
  );
}
